import React from "react";
import { useInView } from "react-intersection-observer";
import styles from "../styles/Projects.module.css";

const ProjectCard = ({ project }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <a
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.projectCardLink}
    >
      <div
        ref={ref}
        className={styles.projectCard}
        style={{
          opacity: inView ? 1 : 0,
          transform: inView ? "translateY(0)" : "translateY(20px)",
        }}
      >
        {project.image && (
          <img
            src={project.image}
            alt={`Image for ${project.title}`}
            className={styles.projectImage}
          />
        )}
        <h2 className={styles.projectTitle}>{project.title}</h2>
        <p className={styles.projectDescription}>{project.description}</p>
      </div>
    </a>
  );
};

const AboutProjects = () => {
  const projects = [
    {
      title: "AI ethics in journalism",
      description:
        "Developed Poynter's AI strategy, led two summits and wrote our global ethics guidelines.",
      link: "https://www.poynter.org/poynter-ai-leadership/",
      image: "/images/ai-ethics.jpg",
    },
    {
      title: "Find Facts Fast: A media literacy SMS course",
      description:
        "Led the editorial development of a text message course featuring celebrity and journalist ambassadors.",
      link: "https://www.poynter.org/mediawise/programs/find-facts-fast/",
      image: "/images/find-facts.jpg",
    },
    {
      title: "Come at Me, Sarasota: A digital video series",
      description:
        "Bested Man vs. Food's Adam Richman as part of an innovative local news product.",
      link: "https://youtu.be/re7c3LXMxys?feature=shared&t=268",
      image: "/images/sarasota.jpg",
    },
    {
      title: "Teaching the world AI literacy",
      description:
        "Worked on MediaWise's AI literacy curriculum to help everyday people — from teens to retirees — make sense of AI-generated content.",
      link: "https://www.poynter.org/mediawise/ailiteracy/",
      image: "/images/ai-literacy.jpg",
    },
    {
      title: "An AI bot that fact-checks politics",
      description:
        "Built an AI Community Notes writer that flags political misinformation on X, with a public dashboard tracking every note and every refusal.",
      link: "https://alexmahadevan.github.io/cn-bot/",
      image: "/posts/2026-05-30-cn-bot-chickadee.jpg",
    },
    {
      title: "Proving older adults can teach AI literacy",
      description:
        "Partnered with Google's Jigsaw and Stanford on short videos — featuring older adults teaching the skills — that reached more than 10 million viewers.",
      link: "https://www.poynter.org/mediawise/programs/seniors/",
      image: "/images/seniors-study.jpg",
    },
  ];

  return (
    <div className={styles.projectsContainer}>
      <h1 className={styles.title}>Some projects</h1>
      <p className={styles.description}>
        I've worked all over the newsroom — from covering county government to shooting videos and writing newsletters. Following my time in local news, I've developed media literacy products, co-led research and created curricula for college students and older adults.
      </p>
      <div className={styles.projectsGrid}>
        {projects.map((project, index) => (
          <ProjectCard key={index} project={project} />
        ))}
      </div>
    </div>
  );
};

export default AboutProjects;
